import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Dialog } from "primereact/dialog";
import { RTU } from "../../types/RTU";
import React from "react";
import { useNavigate } from "react-router-dom";
import { normalizeSoftwareVersion } from "./dashboardVersionNormalization";
import { formatProducerName } from "../../utils/rtuDefaults";
import { useTranslation } from "react-i18next";

interface PopupProps {
  rtus: RTU[];
  onClose: () => void;
}

const PopupComponent: React.FC<PopupProps> = ({ rtus, onClose }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const openRtuDetail = (event: any) => {
    const rtuId = event.data.id;
    const rtu = rtus.find((item) => item.id === rtuId);
    navigate(`/rtupage/${rtuId}`, { state: { rtu } });
  };

  const version = rtus.length > 0 ? normalizeSoftwareVersion(rtus[0].deploymentVersion) : "";
  const allSameVersion = rtus.every(
    (rtu) => normalizeSoftwareVersion(rtu.deploymentVersion) === version
  );

  if (!allSameVersion) {
    return (
        <Dialog
          header="RTUs version: other"
          visible
          className="dashboard-status-detail-dialog"
          style={{ width: "min(64rem, calc(100vw - 7rem))", maxWidth: "96vw" }}
          contentStyle={{ padding: "0.75rem 1rem 1rem" }}
          headerStyle={{ padding: "0.75rem 1rem", borderBottom: "1px solid #e9ecef" }}
          modal
          onHide={onClose}
          blockScroll
        >
          <DataTable
            value={rtus}
            onRowClick={openRtuDetail}
            rowClassName={() => "dashboard-status-detail-dialog__row"}
            scrollHeight="360px"
            scrollable
            showGridlines
            size="small"
            stripedRows
            tableStyle={{ width: "100%", tableLayout: "fixed" }}
          >
            <Column
              field="id"
              header={t("dashboard.tables.columns.wellId", { defaultValue: "Well ID" })}
              style={{ width: "7rem" }}
              bodyStyle={{ textAlign: "center" }}
            />
            <Column
              field="name"
              header={t("dashboard.tables.columns.rtuId", { defaultValue: "RTU ID" })}
              style={{ width: "24%" }}
            />
            <Column
              field="provider"
              header="Producer"
              style={{ width: "28%" }}
              body={(row: RTU) => formatProducerName(row.provider)}
            />
            <Column
              field="deploymentVersion"
              header="Version"
              style={{ width: "24%" }}
            />
          </DataTable>
        </Dialog>
    );
  }

  return (
      <Dialog
        header={`RTUs version: ${version}`}
        visible
        modal
        className="dashboard-status-detail-dialog"
        style={{ width: "min(64rem, calc(100vw - 7rem))", maxWidth: "96vw" }}
        contentStyle={{ padding: "0.75rem 1rem 1rem" }}
        headerStyle={{ padding: "0.75rem 1rem", borderBottom: "1px solid #e9ecef" }}
        onHide={onClose}
        blockScroll
      >
        <DataTable
          value={rtus}
          onRowClick={openRtuDetail}
          rowClassName={() => "dashboard-status-detail-dialog__row"}
          scrollable
          scrollHeight="360px"
          showGridlines
          size="small"
          stripedRows
          tableStyle={{ width: "100%", tableLayout: "fixed" }}
        >
          <Column
            field="id"
            header={t("dashboard.tables.columns.wellId", { defaultValue: "Well ID" })}
            style={{ width: "7rem" }}
            bodyStyle={{ textAlign: "center" }}
          />
          <Column
            field="name"
            header={t("dashboard.tables.columns.rtuId", { defaultValue: "RTU ID" })}
            style={{ width: "34%" }}
          />
          <Column
            field="provider"
            header="Producer"
            style={{ width: "38%" }}
            body={(row: RTU) => formatProducerName(row.provider)}
          />
        </DataTable>
      </Dialog>
  );
};

export default PopupComponent;
